export default __webpack_public_path__ + "static/media/affImg.62403221.webp";